<template>
    <div id="manage-plan-page">
        <AppHero
            :heading="'Account Activity'"
        />

        <section class="account-activity">
            <div class="container container--mw-xxl">
                <table class="account-activity__table">
                    <thead class="account-activity__table-head">
                        <tr class="account-activity__table-row account-activity__table-row--head">
                            <th class="account-activity__table-cell account-activity__table-cell--head">Date</th>
                            <th class="account-activity__table-cell account-activity__table-cell--head">Plan</th>
                            <th class="account-activity__table-cell account-activity__table-cell--head">Payment</th>
                            <th class="account-activity__table-cell account-activity__table-cell--head">Status</th>
                        </tr>
                    </thead>

                    <tbody class="account-activity__table-body">
                        <tr v-for="(activityItem, index) in userPayments" :key="index" class="account-activity__table-row">
                            <td class="account-activity__table-cell">{{ activityItem.date }}</td>
                            <td class="account-activity__table-cell">{{ activityItem.plan_name }}</td>
                            <td class="account-activity__table-cell">{{ '£' + (activityItem.amount_total / 100).toFixed(2) }}</td>
                            <td class="account-activity__table-cell">{{ activityItem.payment_status }}</td>
                        </tr>
                    </tbody>

                    <tfoot class="account-activity__table-foot" v-if="moreButtonDisplay">
                        <tr>
                            <td colspan="4" class="account-activity__table-cell account-activity__table-cell--foot">
                                <a href="javascript;" id="load-more-history" class="btn account-activity__more-btn" @click.prevent="incrementCount">More<InlineSvg :src="require(`../assets/svgs/down-arrow.svg`)" class="account-activity__btn-svg" /></a>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </section>

        <CallToAction
            :copy="'Which Khonsu Plan is best for me?'"
            :button-text="'Click here to view our different pricing models'"
            :button-link="'/our-packages'"
        />
    </div>
</template>

<script>
    import AppHero from "@/components/layout/AppHero";
    import CallToAction from "@/components/layout/CallToAction";
    import InlineSvg from "vue-inline-svg";

    export default {
        name: 'ManagePlanPage',
        metaInfo: {
            title: 'Khonsu - ManagePlanPage'
        },
        components: {
            AppHero,
            CallToAction,
            InlineSvg
        },
        data: function () {
            return {
                count: 8
            }
        },
        mounted() {
            this.$store.dispatch('Payment/getallpayments', {
                "userid": sessionStorage.getItem('user_id'),
            });
        },
        computed: {
            userPayments: function() {
                return this.$store.state.Payment.khonsu_userpayments.slice(0,this.count);
            },
            moreButtonDisplay: function() {
                return this.$store.state.Payment.khonsu_userpayments.length <= this.count ? false : true;
            }
        },
        methods: {
            incrementCount() {
                this.count += 8;
            }
        }
    }
</script>